import { useEffect, useState } from 'react'
import { useFeatureFlagsReady } from './useFeatureFlagsReady'

export function useFeatureFlagsReadyWithTimeout(timeoutMs = 3000): boolean {
  const areFlagsReady = useFeatureFlagsReady()
  const [hasTimedOut, setHasTimedOut] = useState(false)

  useEffect(() => {
    if (areFlagsReady) {
      return undefined
    }

    const timeoutId = window.setTimeout(() => setHasTimedOut(true), timeoutMs)
    return () => window.clearTimeout(timeoutId)
  }, [areFlagsReady, timeoutMs])

  return areFlagsReady || hasTimedOut
}
